import React from 'react';

const BookTour: React.FC = () => {
  const dates = [
    { day: 'Mon', date: '12', active: false },
    { day: 'Tue', date: '13', active: true },
    { day: 'Wed', date: '14', active: false },
    { day: 'Thu', date: '15', active: false },
    { day: 'Fri', date: '16', active: false },
  ];

  const times = ['10:00 AM', '11:30 AM', '02:00 PM', '03:30 PM'];

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-bold text-white">Book a Tour</h1>
        <p className="text-white/60 text-sm">Experience our premium facilities in person.</p>
      </div>

      <div className="space-y-4">
        <h3 className="text-sm font-bold text-white uppercase tracking-wider">Select Date</h3>
        <div className="flex justify-between gap-2 overflow-x-auto pb-2 no-scrollbar">
          {dates.map((item, idx) => (
            <button 
              key={idx}
              className={`flex min-w-[60px] flex-col items-center justify-center rounded-2xl border p-3 transition-all ${
                item.active 
                  ? 'border-primary bg-primary text-black shadow-lg shadow-primary/20' 
                  : 'border-white/10 bg-white/5 text-white hover:bg-white/10'
              }`}
            >
              <span className="text-xs opacity-80">{item.day}</span>
              <span className="text-xl font-bold">{item.date}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-sm font-bold text-white uppercase tracking-wider">Select Time</h3>
        <div className="grid grid-cols-2 gap-3">
          {times.map((time, idx) => (
            <button 
              key={idx}
              className="rounded-lg border border-white/10 bg-white/5 py-3 text-sm font-medium text-white transition-all hover:border-primary/50 hover:bg-white/10 focus:border-primary focus:bg-primary/10"
            >
              {time}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-auto pt-8">
        <button className="w-full rounded-full bg-white/10 p-4 font-bold text-white transition-transform active:scale-95 hover:bg-white/20">
          Confirm Booking
        </button>
      </div>
    </div>
  );
};

export default BookTour;